/* /all-products and Item Group pages (both, item_group.html loads the same
 * all-products/index.js) - presence-detected mount, same shape as
 * wishlist_page.js/trial_room_page.js. Gates on #rfhq-catalog-filters
 * existing, so the two raftor_webhq shadow templates
 * (www/all-products/index.html, templates/generators/item_group.html) are
 * the only place this ever finds its anchor.
 */

import { RfhqCatalogFilters } from './catalog_filters.js';
import { mountGroupTiles } from './group_tiles.js';

frappe.ready(function () {
	var el = document.getElementById('rfhq-catalog-filters');
	if (!el) return; // not this page

	var groupEl = document.querySelector('.item-group-content[data-item-group]');
	var itemGroup = groupEl ? groupEl.getAttribute('data-item-group') : null;

	// Same "?search= present" detection as search_results_heading.js -
	// horizontal layout is specifically for the search-results view of
	// /all-products, never for Item Group pages (they never carry ?search=).
	var isSearch = new URLSearchParams(window.location.search).has('search');
	var layout = isSearch ? 'horizontal' : 'vertical';

	// Admin override (Website HQ Settings > Catalog Listing > Catalog Filter
	// Layout), injected as window.rfhqCatalogFilterLayout by
	// website_hq_settings.py. "Auto" (or unset/unrecognized) keeps the
	// search-based rule above; the other two force one layout on every page
	// this mounts on, including search results.
	if (window.rfhqCatalogFilterLayout === 'Always Vertical') layout = 'vertical';
	else if (window.rfhqCatalogFilterLayout === 'Always Horizontal') layout = 'horizontal';

	// The mount point is the same col-md-3 sidebar slot in both templates -
	// the CSS layout toggle alone only changes the flex-direction *inside*
	// #rfhq-catalog-filters, it can't widen the column that traps it.
	// Horizontal needs to physically move out of that column into a
	// full-width slot above the row (same pattern search_results_heading.js
	// already uses for its own heading), or it just renders as a narrow,
	// cramped vertical stack with a horizontal CSS class doing nothing.
	if (layout === 'horizontal') {
		var sidebarColumn = el.parentElement;
		var row = sidebarColumn.closest('.row');
		if (row) {
			row.parentElement.insertBefore(el, row);
			sidebarColumn.remove(); // now-empty col-md-3, no longer reserving width

			// #product-listing's col-md-9 assumed a sidebar sharing the row -
			// widen it to fill the space that column just gave up.
			var listing = document.getElementById('product-listing');
			if (listing) listing.classList.replace('col-md-9', 'col-md-12');
		}
	}

	var filters = new RfhqCatalogFilters({ el: el, layout: layout, itemGroup: itemGroup });
	// On the whole store (not one group's page) the groups are tiles over the listing, and the panel no longer lists them as ticks.
	if (!itemGroup && !isSearch) {
		var row = el.closest('.row');
		if (row && row.parentElement) {
			var tilesHost = document.createElement('div');
			tilesHost.id = 'rfhq-group-tiles';
			tilesHost.className = 'rfhq-group-tiles';
			row.parentElement.insertBefore(tilesHost, row);
			filters.groupTiles = true;
			mountGroupTiles(tilesHost, function () { filters._restoreFromUrl(); filters.render(); });
		}
	}
	filters.render();

	// The grid gets this treatment for itself (_applySiteThemeFallback());
	// this component isn't the grid, so it needs to claim it explicitly -
	// same reasoning as catalog_filters_theme.js's now-retired equivalent
	// for the old #product-filters sidebar.
	el.setAttribute('data-rfhq-owned', '1');
	if (window.rfhqApplyOwnedThemeFallback) window.rfhqApplyOwnedThemeFallback(el);
});
